export const categories = [
  {
    id: "cat-1",
    nameEn: "Electronics",
    nameAr: "إلكترونيات",
    slug: "electronics",
    imageUrl: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20electronics%20and%20gadgets%20flat%20lay%20with%20headphones%20smartphone%20and%20smartwatch%20on%20clean%20warm%20beige%20background%2C%20product%20photography%20style%20with%20soft%20natural%20lighting%2C%20simple%20composition&width=800&height=800&seq=cat-electronics-01&orientation=squarish",
    itemCount: 124,
  },
  {
    id: "cat-2",
    nameEn: "Fashion",
    nameAr: "أزياء",
    slug: "fashion",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20fashion%20accessories%20flat%20lay%20with%20watch%20sunglasses%20and%20leather%20wallet%20on%20warm%20cream%20background%2C%20editorial%20product%20photography%20with%20soft%20diffused%20lighting%2C%20clean%20composition&width=800&height=800&seq=cat-fashion-02&orientation=squarish",
    itemCount: 89,
  },
  {
    id: "cat-3",
    nameEn: "Home & Living",
    nameAr: "المنزل والمعيشة",
    slug: "home-living",
    imageUrl: "https://readdy.ai/api/search-image?query=Stylish%20modern%20home%20decor%20items%20flat%20lay%20with%20ceramic%20vase%20candle%20and%20decorative%20objects%20on%20warm%20beige%20surface%2C%20minimalist%20product%20photography%20with%20natural%20soft%20lighting&width=800&height=800&seq=cat-home-03&orientation=squarish",
    itemCount: 156,
  },
  {
    id: "cat-4",
    nameEn: "Beauty",
    nameAr: "جمال",
    slug: "beauty",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20beauty%20and%20skincare%20products%20flat%20lay%20with%20serum%20bottles%20cream%20jars%20and%20natural%20elements%20on%20warm%20cream%20background%2C%20luxury%20product%20photography%20with%20soft%20gentle%20lighting&width=800&height=800&seq=cat-beauty-04&orientation=squarish",
    itemCount: 98,
  },
  {
    id: "cat-5",
    nameEn: "Sports & Outdoors",
    nameAr: "الرياضة والهواء الطلق",
    slug: "sports-outdoors",
    imageUrl: "https://readdy.ai/api/search-image?query=Minimalist%20sports%20and%20fitness%20equipment%20flat%20lay%20with%20water%20bottle%20resistance%20bands%20and%20yoga%20mat%20on%20warm%20beige%20background%2C%20clean%20product%20photography%20with%20bright%20natural%20lighting&width=800&height=800&seq=cat-sports-05&orientation=squarish",
    itemCount: 67,
  },
  {
    id: "cat-6",
    nameEn: "Kitchen & Dining",
    nameAr: "المطبخ وتناول الطعام",
    slug: "kitchen-dining",
    imageUrl: "https://readdy.ai/api/search-image?query=Modern%20kitchen%20utensils%20and%20dining%20accessories%20flat%20lay%20with%20wooden%20spoons%20ceramic%20bowls%20and%20linen%20napkin%20on%20warm%20beige%20surface%2C%20editorial%20product%20photography%20with%20soft%20natural%20light&width=800&height=800&seq=cat-kitchen-06&orientation=squarish",
    itemCount: 112,
  },
];

export const allCategories = categories;